import { render } from "./OidcCallbackErrorPage.vue?vue&type=template&id=226a265c"
import script from "./OidcCallbackErrorPage.vue?vue&type=script&lang=js"
export * from "./OidcCallbackErrorPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__